module.exports = {
  cookiePolicyBar: {
    text: 'We uses cookies to improve your experience on our website. By using this website, you consent to the use of cookies. See our <a href="/en/privacy-policy">privacy policy</a>.',
  },
  booking_button: {
    text: 'Inquire now!',
    url: '/en/booking-inquiry',
  },
  footer: {
    phone: 'Phone',
    email: 'Mail',
    socialMediaRecommendUs: 'Recommend us:',
    findUsOnFB: 'VSB United on Facebook:',
  },
  form_send_error: 'An error occurred while submitting the form. Please check your data and try again.',
  inquiry_form: {
    please_choose: 'please choose ...',
    accommodation_selection: {
      title: 'Request for our',
      apartment: 'Holiday apartment',
      home: 'Holiday home',
      room: 'Holiday room',
    },
    booking_period: {
      title: 'Booking period',
      arrivalDate: 'Date of arrival',
      departureDate: 'Date of departure',
    },
    people: {
      title: 'Number of people',
      adults: 'Adults',
      children: 'Children',
      ageOfChildren: 'Age of children (for exact calculation of the offer)',
    },
    personal_data: {
      title: 'Personal data',
      salutation: 'Salutation',
      salutation_f: 'Ms / Mrs',
      salutation_m: 'Mr',
      salutation_family: 'Family',
      salutation_c: 'Company',
      salutation_title: 'Title',
      company: 'Company',
      firstName: 'Firstname',
      lastName: 'Lastname',
    },
    address_data: {
      title: 'Address data',
      street: 'Street, house number',
      zip: 'Postal code / zip',
      city: 'City',
      country: 'Country',
      countries: {
        AT: 'Austria',
        DE: 'Germany',
        CH: 'Switzerland',
        BE: 'Belgium',
        FL: 'Finland',
        FR: 'France',
        GB: 'Great Britain',
        HU: 'Hungary',
        CZ: 'Czech Republic',
        SL: 'Slovakia',
        IT: 'Italy',
        NL: 'Netherlands',
        NO: 'Norway',
        ES: 'Spain',
        PO: 'Poland',
        LI: 'Liechtenstein',
        RO: 'Romania',
        US: 'USA',
      }
    },
    contact_data: {
      title: 'Contact details',
      email: 'E-mail',
      emailConfirm: 'E-mail confirm',
      phone: 'Phone',
    },
    message: {
      title: 'Comment or message',
      info: 'Leave a personal message or other comments.',
    },
    button: {
      title: 'Send booking inquiry',
    }
  }
}